module.exports = __webpack_public_path__ + "static/media/hero__tournament-default.4808a082.jpg";